/* ==========================================================
   MISS SWIG - product card add to cart
   ----------------------------------------------------------
   One delegated listener for the whole document, so it works
   for cards rendered now and cards injected later. Previously
   this same block was copy-pasted into six sections.
   ========================================================== */
(function () {
  if (window.__msProductCardBound) return;
  window.__msProductCardBound = true;

  function refreshCart() {
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var els = document.querySelectorAll('[data-cart-count], .cart-count, .header__cart-count, .cart-link__bubble');
        for (var i = 0; i < els.length; i++) {
          els[i].textContent = cart.item_count;
          els[i].classList.remove('hidden', 'is-empty');
        }
      })
      .catch(function () {});
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest ? e.target.closest('[data-mspc-form]') : null;
    if (!form) return;
    if (!window.fetch || !window.FormData) return;
    e.preventDefault();

    var btn = form.querySelector('.msfc-atc');
    if (btn && btn.disabled) return;
    var original = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function () {
        if (btn) { btn.textContent = 'Added'; btn.classList.add('added'); }
        refreshCart();
        setTimeout(function () {
          if (btn) {
            btn.innerHTML = original;
            btn.classList.remove('added');
            btn.disabled = false;
          }
        }, 1800);
      })
      .catch(function () {
        if (btn) btn.disabled = false;
        form.submit();
      });
  });
})();
